import React from 'react';
import {
  PaginationInstance,
  PaginationState,
} from '@tanstack/react-table';
import clsx from 'clsx';
import MuiPagination from '@mui/material/Pagination';
import {
  pluralize,
} from 'utils/string';
import Select from 'core/components/Select';

export const pageSizeOptions: number[] = [25, 50, 100];

type Props = PaginationState & Partial<PaginationInstance<any>> & {
  totalItems: number;
  className?: string;
};
export default function Pagination({
  totalItems,
  setPageIndex,
  setPageSize,
  pageIndex,
  pageSize,
  className,
}: Props) {
  const pageCount = Math.ceil(totalItems / pageSize);
  return (
    <div className={clsx('flex flex-row justify-between w-full px-4', className)}>
      <div className="flex flex-row items-center justify-start text-xs">
        Rows per page:
        <Select<number>
          selectClassName="!border-0 relative top-0.5"
          value={pageSize}
          options={pageSizeOptions}
          getValue={(option) => option}
          getLabel={(option) => option.toString()}
          onChange={(option: number | number[]) => { setPageSize!(option as number); }}
        />
      </div>
      <div className="flex flex-row items-center">
        <div className="!text-xs">
          {pageIndex * pageSize + 1}
          -
          {Math.min((pageIndex + 1) * pageSize, totalItems)}
          {' of '}
          {pluralize('item', totalItems)}
        </div>
        <MuiPagination
          size="small"
          page={pageIndex + 1}
          siblingCount={0}
          boundaryCount={2}
          onChange={(event, page: number) => {
            if (page - 1 !== pageIndex) {
              setPageIndex!(page - 1);
            }
          }}
          count={pageCount}
        />
      </div>
    </div>
  );
}
